<template>
    <div>
        <div class="tab mb-0">
            <ul class="nav nav-tabs" role="tablist">
                <li v-if="$hasPermission('requests.comments.create')" class="nav-item"><a class="nav-link active" :href="'#request-action-tab-1-' + _uid" data-toggle="tab" role="tab">Комментарий</a></li>
                <li v-if="$hasPermission('requests.sms.create')" class="nav-item"><a class="nav-link" :href="'#request-action-tab-2-' + _uid" data-toggle="tab" role="tab">СМС</a></li>
                <li v-if="$hasPermission('requests.reminders.create')" class="nav-item"><a class="nav-link" :href="'#request-action-tab-3-' + _uid" data-toggle="tab" role="tab">Напоминание</a></li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane fade show active" :id="'request-action-tab-1-' + _uid" role="tabpanel" v-if="$hasPermission('requests.comments.create')">
                <div class="card">
                    <div class="card-body">
                        <AddRequestComment :request_id="request.id"/>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" :id="'request-action-tab-2-' + _uid" role="tabpanel" v-if="$hasPermission('requests.sms.create')">
                <div class="card">
                    <div class="card-body">
                        <AddRequestSms :request="request"/>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" :id="'request-action-tab-3-' + _uid" role="tabpanel" v-if="$hasPermission('requests.reminders.create')">
                <div class="card">
                    <div class="card-body">
                        <AddRequestReminder :request="request"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AddRequestComment from "./actions/AddRequestComment";
    import AddRequestSms from "./actions/AddRequestSms";
    import AddRequestReminder from "./actions/AddRequestReminder";
    export default {
        name: "RequestActions",
        components: {AddRequestReminder, AddRequestSms, AddRequestComment},
        props: ["request"],
    }
</script>

<style scoped>

</style>
